Vue.component("MpAccordionItem", {
    inject: ['accordionData'],

    props: {
        id: String,
        dataImg: String
    },

    data: function() {
        return {
            contentOffsetHeight: 0,

            header: null,
            content: null,
            contentInner: null,
        };
    },

    computed: {
        isOpen: function() {
            return this.id === this.accordionData.itemSelected;
        },

        getStyle: function() {
            return 'max-height: ' + ((this.isOpen) ? this.contentOffsetHeight + 'px' : '0px');
        }
    },

    methods: {
        init: function() {
            this.contentOffsetHeight = this.contentInner.offsetHeight;
        },

        onSelect: function() {
            this.$parent.$emit(EVENT_ACCORDION.ITEM_CLICKED, {
                id: this.id,
                img: this.dataImg
            });
        }
    },

    mounted: function() {
        this.header = this.$refs.header;
        this.content = this.$refs.content;
        this.contentInner = this.$refs.contentInner;

        this.init();
    },

    template: '\
    <div class="accordion-item" :class="{ \'accordion-item--open\': isOpen }" :id="id" :data-img="dataImg" @click="onSelect">\
\
        <div class="accordion-item__header" ref="header">\
            <slot name="label"></slot>\
\
            <div class="accordion-item__header-icon icon">\
                <slot name="icon">\
                    <svg class="icon__inner" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m12.563 5.25 6.75 6.75-6.75 6.75M18.375 12H4.687" style="stroke:currentColor;stroke-opacity:1"/></svg>\
                </slot>\
            </div>\
        </div>\
\
        <div class="accordion-item__content" :style="getStyle" ref="content"">\
            <div class="accordion-item__content-inner" ref="contentInner">\
                <slot name="content"></slot>\
            </div>\
        </div>\
\
    </div>',
});
